import { gql } from '@apollo/client';

const getTaxQuoteQueries = gql `
  query (
    $street1: String!
    $city: String!
    $state: String!
    $postalCode: String!
    $country: String!
    $currencyCode: String!
    $orgID: UUID1!
    $taxablePrice: Float!
  ) {
    getTaxQuote(
      input: {
        address: {
          street1: $street1
          city: $city
          state: $state
          postalCode: $postalCode
          country: $country
          currencyCode: $currencyCode
        }
        orgID: $orgID
        taxablePrice: $taxablePrice
      }
    ) {
      verifiedAddress {
        street1
        state
        postalCode
        country
        currencyCode
      }
      taxablePrice
      totalTaxedPrice
      totalTaxAmount
    }
  }
`;
const estimateTaxAndRoyaltyFeeMutation = gql `
  mutation estimateTaxAndRoyaltyFee(
    $orderId: UUID1
    $orgId: UUID1!
    $nftTokenId: UUID1
    $price: Float
    $estimateType: TaxEstimateType!
    $country: String
    $postalCode: String
  ) {
    estimateTaxAndRoyaltyFee(
      orgId: $orgId
      orderId: $orderId
      nftTokenId: $nftTokenId
      price: $price
      estimateType: $estimateType
      country: $country
      postalCode: $postalCode
    ) {
      taxPercentage
      royaltyFee
      platformFee
      taxResponse {
        cryptoTaxPrice
        cryptoTotalPrice
        USDUnitprice
        taxPercentage
      }
    }
  }
`;

export { estimateTaxAndRoyaltyFeeMutation, getTaxQuoteQueries };
